// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__J7B_P","content":"ManualTimeModal_content__2KJYw"};